import {
  makeObservable, observable, flow, action,
} from 'mobx';
import { toast } from 'sonner';

import { api } from '@/lib/services';
import { ApiRoutes } from '@/lib/routes';

export default class SchedulerActivityStore {
  loading = false;

  loaded = false;

  tiers = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      loaded: observable,
      tiers: observable,
      reset: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  reset() {
    this.tiers = [];
    this.loaded = false;
  }

  * load() {
    try {
      this.loading = true;
      const response = yield api.get(ApiRoutes.forSegmentSchedulerActivity());
      this.tiers = response.data?.tiers ?? [];
      this.loaded = true;
      return { success: true };
    } catch (e) {
      toast.error('Could not load scheduler activity', {
        description: e?.response?.data?.message || 'Unexpected error.',
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
